import React, { CSSProperties, useContext } from 'react';
import { useLocalStorage } from 'react-use';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import logoImg from 'shared/images/logo.png';
import { routes } from 'config';
import { LayoutContext } from 'contexts/LayoutContext/LayoutContext';
import { SidebarCollapseIcon, SidebarExpandIcon } from 'shared/icons/NavIcons/SidebarCollapseIcon';
import { UserNavItems } from './UserNavItems';

const AnimTimes = [300, 200];

export const UserNav = () => {

  const { isResizing, setIsResizing } = useContext(LayoutContext);
  const navigate = useNavigate();

  const [isCollapsed, setIsCollapsed] = useLocalStorage<boolean>('user-nav-collapsed', false);
  const [navStyle, setNavStyle] = React.useState<CSSProperties>({});

  const handleCollapse = React.useCallback(() => {
    setIsCollapsed(!isCollapsed);
    setIsResizing(true);
    setTimeout(() => setIsResizing(false), AnimTimes[0] + AnimTimes[1]);
  }, [isCollapsed, setIsCollapsed, setIsResizing]);

  React.useEffect(() => {
    if (!isResizing) {
      setNavStyle({
        '--logo-transition': isCollapsed ? (
          'var(--t2) opacity var(--t1), margin-right var(--t1), width var(--t1)'
        ) : (
          'calc(var(--t1) / 2) opacity, var(--t1) margin-right, var(--t1) width'
        ),
      } as CSSProperties);
    }
  }, [isResizing, isCollapsed]);

  return (
      <nav
        className={`layout-user-nav ${isCollapsed ? 'is-collapsed' : ''}`}
        style={{
          '--t1': AnimTimes[0] + 'ms',
          '--t2': AnimTimes[1] + 'ms',
          ...navStyle,
        } as CSSProperties}
      >
        <div className="header">
          <div className="logo">
          <img src={logoImg} alt="Coolset" onClick={() => navigate(routes.surveys)}/>
          </div>

          <IconButton onClick={handleCollapse} color="secondary">
            {isCollapsed ? <SidebarExpandIcon/> : <SidebarCollapseIcon/>}
          </IconButton>
        </div>

        <UserNavItems isCollapsed={!!isCollapsed}/>
      </nav>
  );
};

